import { CalendarItemType } from '$tablet-app/src/app/models';
import { layout, margins } from '$tablet-app/src/app/theme';
import React, { FC } from 'react';
import { ModalProps, StyleSheet } from 'react-native';
import NewButton from '../Button/NewButton';
import DeleteModal from '../DeleteModal';

interface CalendarItemRef {
  id: string;
  type: CalendarItemType;
}

interface CalendarItemRecurrenceDeleteConfirmationProps extends ModalProps {
  item: CalendarItemRef;
  onConfirmDeleteAll: (item: CalendarItemRef) => void;
  onConfirmDeleteSingle: (item: CalendarItemRef) => void;
  onConfirmDeleteFollowing?: (item: CalendarItemRef) => void;
  onCancel: () => void;
}

const CalendarItemRecurrenceDeleteConfirmation: FC<
  CalendarItemRecurrenceDeleteConfirmationProps
> = (props) => {
  const {
    onConfirmDeleteAll,
    onConfirmDeleteSingle,

    item,
    ...rest
  } = props;
  return (
    <DeleteModal
      title={`Delete this ${item.type}.`}
      subtitle={`This ${item.type} is recurring. Please choose if you would like to delete just this ${item.type} or all recurring ${item.type}s of it's type.`}
      {...rest}
    >
      <NewButton
        style={styles.button}
        onPress={() => onConfirmDeleteSingle(item)}
      >
        Delete this {item.type}
      </NewButton>

      <NewButton style={styles.button} onPress={() => onConfirmDeleteAll(item)}>
        Delete all recurring {item.type}s
      </NewButton>

      {/* Hiding this for now for the sake of simplicity for users. May reintroduce later. */}
      {/* <Button
        style={styles.button}
        onPress={() => onConfirmDeleteFollowing(item)}
        text={`Delete this and all following ${item.type}s`}
      /> */}
    </DeleteModal>
  );
};

// Styles
const styles = StyleSheet.create({
  button: {
    ...layout.fullWidth,
    ...margins.mb2,
  },
});

export default CalendarItemRecurrenceDeleteConfirmation;
